<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>上传SN号</span>
                </div>
            </div>
            <div class="upload_box">
                <div class="upload_file">
                    <el-input class="projectId" v-model="projectId" placeholder="请输入秘钥"></el-input>
                    <el-upload
                        class="upload-btn"
                        ref="uploadFile"
                        :action="uploadUrl"
                        :headers="{'Authorization': 'Bearer ' + ($store.state.token)}"
                        :data="{project_id: projectId}"
                        :file-list="importFile"
                        :show-file-list="false"
                        :on-change="uploadChange"
                        :limit="2"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.csv"
                        :auto-upload="false">
                        <div class="button">
                            <i class="el-icon-upload2"></i>
                            <span>选择文件</span>
                        </div>&nbsp;&nbsp;
                    </el-upload>
                </div>
                <p class="importFileName" v-if="importFile.length > 0">
                    <span>{{importFile[0] ? importFile[0].name : ''}}</span>
                    <i class="el-icon-close" @click="delImportFile"></i>
                </p>
                <div class="button confirm" :class="(importFile && importFile.length > 0 && projectId) ? 'info_update' : 'not_act'" @click="uploadFile" v-if="roleCheck('106-102-101-102')">
                    <span v-show="!lodding">上传</span>
                    <span v-show="lodding">上传中...</span>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
export default({
    name: 'cb-upload-sn',
    data() {
        return {
            projectId: '',  // a123nCqsrQm3vEbt
            importFile: [],
            uploadUrl: process.env.BASE_API + 'tool/import',
            lodding: false
        }
    },
    created() {
        
    },
    methods: {
        uploadChange(file, fileList) {
            this.lodding = false;
            if(file.response) {
                if(file.response.code != 200) {
                    if(file.response.code == 1012) {
                        this.$message.error('用户暂无此权限');
                        return;   
                    }
                    this.$message.error(file.response.msg || file.response.message);
                    this.lodding = false;
                    this.importFile = [];
                    this.$refs.uploadFile.clearFiles();
                }else{
                    this.$message.success('导入成功！');
                    this.importFile = [];
                    this.$refs.uploadFile.clearFiles();
                    this.$emit('uploadChange', file, fileList);
                }
            }else{
                this.importFile = fileList.slice(-1);
            }
            
        },
        uploadFile() {
            if(this.importFile && this.importFile.length > 0 && this.projectId && !this.lodding) {
                this.lodding = true;
                this.$refs.uploadFile.submit();
            }
        },
        delImportFile() {
            this.$refs.uploadFile.abort(this.importFile[0]);
            this.importFile = [];
            this.$refs.uploadFile.uploadFiles.splice(0, 1);
        }
    }
})
</script>
<style lang="less" scoped>
    .projectId{
        width: 200px;
        margin-bottom: 20px;
    }
    .importFileName{
        margin-top: 10px;
        .el-icon-close{
            margin-left: 60px;
        }
    }
    
    .confirm{
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/cat-box/upload-sn.vue